// upload file type
export const BRIEF = 1
export const PROPOSAL = 2
export const QUOTATION = 3
export const SPOTPLAN = 4
export const SINGATURE = 5
export const REPORT = 6

export const phaseTypeToNameMap = {
  1: 'Request & Brief',
  2: 'Proposal & Quotation',
  3: 'Contract & DO',
  4: 'Report',
  5: 'Brief',
  6: 'Order',
  7: 'Proposal & Quotation'
}

export const phaseTypeToName = (phaseType) => phaseTypeToNameMap[phaseType]

const checkInteger = function (val) {
  if (val === '') return
  if (isNaN(Number(val))) return false
  return Number.isInteger(Number(val))
}

export const checkFix2 = function (val) {
  if (val === '') return
  if (isNaN(Number(val))) return false
  return /^\d+(\.\d{1,2})?$/.test(Number(val))
}

const checkFix2AndLt100 = function (val) {
  if (val === '') return
  if (isNaN(Number(val))) return false
  return /^\d+(\.\d{1,2})?$/.test(Number(val)) && Number(val) <= 100
}

export const KPIMap = [
  {
    kpiName: '曝光',
    kpiId: 1,
    format: 'numberWithCommas',
    validate: checkInteger,
    validateMessage: '必须为整数',
    unit: '次'
  },
  {
    kpiName: '点击',
    kpiId: 2,
    format: 'numberWithCommas',
    validate: checkInteger,
    validateMessage: '必须为整数',
    unit: '次'
  },
  {
    kpiName: '点击率',
    kpiId: 3,
    format: 'numberWithPercent',
    validate: checkFix2AndLt100,
    validateMessage: '最多为两位小数且小于等于100%',
    unit: '%'
  },
  {
    kpiName: '互动量',
    kpiId: 4,
    format: 'numberWithCommas',
    validate: checkInteger,
    validateMessage: '必须为整数',
    unit: '次'
  },
  {
    kpiName: '互动率',
    kpiId: 5,
    format: 'numberWithPercent',
    validate: checkFix2AndLt100,
    validateMessage: '最多为两位小数且小于等于100%',
    unit: '%'
  },
  {
    kpiName: '发布量',
    kpiId: 6,
    format: 'numberWithCommas',
    validate: checkInteger,
    validateMessage: '必须为整数',
    unit: '次'
  },
  {
    kpiName: 'CPM',
    kpiId: 7,
    format: 'formatMoney',
    validate: checkFix2,
    validateMessage: '最多为两位小数',
    unit: '元'
  },
  {
    kpiName: 'CPC',
    kpiId: 8,
    format: 'formatMoney',
    validate: checkFix2,
    validateMessage: '最多为两位小数',
    unit: '元'
  }
]

// export const PROCESS_STATUS = {
//   1: '待填报价',
//   2: '待填结案报告',
//   3: '待评价',
//   4: '完成'
// }
export const PROCESS_STATUS = {
  1: '进行中',
  2: '进行中',
  3: '进行中',
  4: '已完成'
}
export const ROUTER_MAP = {
  'procurement-select-vendor': 'procurement-select-vendor-v3'
}

export const getIONumber = function (mediaTypeName) {
  switch (mediaTypeName) {
    case 'CPD-资源包':
    case 'CPD-品牌专区':
      return 'KL'
    case 'RTB-付费搜索':
      return 'K5'
    case '淘宝客/京挑客':
      return 'KC'
    default:
      return 'KD'
  }
}

export const postfixToImgCode = {
  other: require('@/umcc/assets/img_other.png'),
  xlsx: require('@/umcc/assets/img_excel.png'),
  pdf: require('@/umcc/assets/img_pdf.png'),
  ppt: require('@/umcc/assets/img_ppt.png'),
  mp4: require('@/umcc/assets/img_video.png'),
  doc: require('@/umcc/assets/img_word.png'),
  zip: require('@/umcc/assets/img_zip.png')
}
